(() => {
  const body = document.querySelector('.aq-policy-terms .shopify-policy__body .rte');
  if (!body || body.dataset.organized) return;
  body.dataset.organized = 'true';
  const replacements = new Map([
    ['[LINK TO REFUND POLICY]', ['/policies/refund-policy', 'Refund Policy']],
    ['[LINK TO PRIVACY POLICY]', ['/policies/privacy-policy', 'Privacy Policy']],
    ['info@archquick.com.au', ['mailto:info@archquick.com.au', 'info@archquick.com.au']]
  ]);
  const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  const texts = [];
  while (walker.nextNode()) texts.push(walker.currentNode);
  texts.forEach((node) => {
    if (node.parentElement.closest('a')) return;
    const parts = node.textContent.split(/(\[LINK TO REFUND POLICY\]|\[LINK TO PRIVACY POLICY\]|info@archquick\.com\.au)/g);
    if (parts.length === 1) return;
    const fragment = document.createDocumentFragment();
    parts.forEach((part) => {
      if (!replacements.has(part)) { fragment.append(document.createTextNode(part)); return; }
      const [href, label] = replacements.get(part);
      const link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      fragment.append(link);
    });
    node.replaceWith(fragment);
  });
  const headings = [...body.querySelectorAll('strong')].filter((node) => /^(OVERVIEW|SECTION \d+ -)/.test(node.textContent.trim()));
  if (!headings.length) return;
  const nodes = [];
  [...body.childNodes].forEach((node) => {
    if (node.nodeType === 1 && node.tagName === 'P') nodes.push(...node.childNodes);
    else nodes.push(node);
  });
  const fragment = document.createDocumentFragment();
  const nav = document.createElement('nav');
  nav.className = 'aq-terms-index';
  nav.setAttribute('aria-label', document.querySelector('.shopify-policy__title').textContent.trim());
  let section = fragment;
  let paragraph;
  nodes.forEach((node) => {
    if (headings.includes(node)) {
      section = document.createElement('section');
      section.className = 'aq-terms-section';
      const heading = document.createElement('h2');
      heading.textContent = node.textContent.trim();
      heading.id = 'aq-terms-' + nav.children.length;
      section.setAttribute('aria-labelledby', heading.id);
      section.append(heading);
      fragment.append(section);
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      nav.append(link);
      paragraph = null;
    } else if (node.nodeType === 1 && node.tagName === 'BR') {
      paragraph = null;
    } else {
      if (!paragraph && !node.textContent.trim()) return;
      if (!paragraph) { paragraph = document.createElement('p'); section.append(paragraph); }
      paragraph.append(node);
    }
  });
  body.replaceChildren(nav, fragment);
})();
